export default __webpack_public_path__ + "static/media/LogoRouge.0dafa328.png";